"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowedQuoteEmailSubjectFields = exports.allowedQuoteEmailMsgFields = exports.allowedInvoiceEmailSubjectFields = exports.allowedInvoiceEmailMsgFields = exports.ReminderParentEntityType = exports.ReminderTriggerType = void 0;
var ReminderTriggerType;
(function (ReminderTriggerType) {
    ReminderTriggerType["AFTER"] = "after";
    ReminderTriggerType["BEFORE"] = "before";
})(ReminderTriggerType = exports.ReminderTriggerType || (exports.ReminderTriggerType = {}));
var ReminderParentEntityType;
(function (ReminderParentEntityType) {
    ReminderParentEntityType["ORDER"] = "order";
    ReminderParentEntityType["INVOICE"] = "invoice";
    ReminderParentEntityType["PAYMENT"] = "payment";
    ReminderParentEntityType["OTHER"] = "other";
    ReminderParentEntityType["QUOTE"] = "quote";
})(ReminderParentEntityType = exports.ReminderParentEntityType || (exports.ReminderParentEntityType = {}));
exports.allowedInvoiceEmailMsgFields = [
    "invoiceNumber",
    "customerName",
    "paymentLink",
    "paymentQRCode",
    "numberOfDays",
    "myCompanyName",
    "myCompanyEmail",
];
exports.allowedInvoiceEmailSubjectFields = [
    "invoiceNumber",
    "customerName",
    "numberOfDays",
    "myCompanyName",
    "myCompanyEmail",
];
exports.allowedQuoteEmailMsgFields = [
    "quoteNumber",
    "customerName",
    "numberOfDays",
    "myCompanyName",
    "myCompanyEmail",
];
exports.allowedQuoteEmailSubjectFields = [
    "quoteNumber",
    "customerName",
    "numberOfDays",
    "myCompanyName",
    "myCompanyEmail",
];
